// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05610601","455":"1a627773","977":"6b752030"}[chunkId] + ".chunk.js";
};